import React, { useRef, useState, Component, useEffect } from "react";
import HTMLFlipBook from "react-pageflip";
import "./FlipbookMainContent.css";
import WelcomeName from "../../function-components/WelcomeName";
import "./topicPageLeft.css";
import "./headerPart.css";
import "./TableOfContent.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Carousel from "react-bootstrap/Carousel";
import FlipbookData from "./FlipbookData.json";
import SapPDF from "../FlipbookContent/SAP-Innovation.pdf";
import { baseUrl } from "../../Constant";
import axios from "axios";
// Cover Page
const PageCover = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref} data-density="hard">
      <div className="contentWrapper">
        <img
          style={{ width: "100%" }}
          src="images/CoverPage1.png"
          alt="CoverImage"
          className="coverImage"
        />
      </div>
    </div>
  );
});

// Table of Content
const PageTOCLeft = React.forwardRef((props, ref) => {
  return (
    <div className="page" ref={ref}>
      <div className="contentWrapper">
        <div className="tocContentContainer">{props.children}</div>
      </div>
    </div>
  );
});
const PageTOCRight = React.forwardRef((props, ref) => {
  return (
    <div className="page" ref={ref}>
      <div className="contentWrapper">
        <div className="tocContentContainer">{props.children}</div>
      </div>
    </div>
  );
});

// Page
const TopicPageLeft = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref}>
      <div className="contentWrapper">
        <div className="topicLeftContainer">
          {/* Topic Left Background Image */}
          <div className="topicLeftLeftImgContainer">
            <img
              src={props.LeftPageBgImage}
              alt=""
              className="topicLeftLeftImg"
            />
          </div>
          {/* Topic Right Text Container */}
          <div className="topicLeftRightContainer">
            <h5 className="topicLeftHeading">
              <span>{props.TopicCount} &nbsp;</span>
              <span style={{ marginLeft: "1%" }}>{props.TopicTitle}</span>
            </h5>
            <div className="topicLeftRightCardContainer">
              {/* Left Card */}
              <div className="topicLeftRightCard topicLeftRightCardLeft">
                {/* Left Card Top Icon */}
                <div className="topicLeftRightCardLeftTopIconContainer">
                  <img
                    src="images/topicAssets/Challenge.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Left Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardLeftTextHeading">Challenge</p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Challenge}
                    <p className="topicLeftRightCardLeftTextP sublists">
                      {props.ChallengeSubchild}
                    </p>
                  </p>
                </div>
              </div>
              {/* Right Card */}
              <div className="topicLeftRightCard topicLeftRightCardsRight">
                {/* Right Card Top Icon */}
                <div className="topicLeftRightCardRightTopIconContainer">
                  <img
                    src="images/topicAssets/Solution.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Right Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardRightTextHeading">Solution</p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Solution}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Subchild}
                  </p>
                </div>
              </div>
            </div>
            <p className="topicPageNumbers">{props.PageNumber}</p>
          </div>
        </div>
      </div>
    </div>
  );
});
const TopicPageRight = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleOpen1 = () => setOpen1(true);
  const handleClose = () => setOpen(false);
  const handleClose1 = () => setOpen1(false);
  return (
    <div className="page page-cover" ref={ref}>
      <div className="contentWrapper">
        <div className="topicRightContainer">
          {/* Topic Right Page Header start*/}
          <div className="topicRightHeaderContainer">
            <p className="topicRightHeaderTextLeft">
              <span className="topicRightHeaderTextSpan">Industry:&nbsp;</span>
              {props.Industry}
            </p>
            <p className="topicRightHeaderTextRight">
              <span className="topicRightHeaderTextSpan">
                Domain/Function:{" "}
              </span>
              {props.Domain}
            </p>
          </div>
          {/* Topic Right Page Header end*/}
          <div className="topicRightTextContainer">
            {/* Topic Right Page Cards start */}
            <div className="topicRightPageLeftCardsContainer">
              {/* Left Card */}
              <div className="topicRightLeftCard topicRightLeftCardLeft">
                {/* Left Card Top Icon */}
                <div className="topicLeftRightCardLeftTopIconContainer">
                  <img
                    src="images/topicAssets/Key.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Left Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardLeftTextHeading">
                    Key Features
                  </p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.KeyFeatures}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Keysubchild}
                  </p>
                </div>
              </div>
              {/* Right Page Right Yellow Card */}
              <div className="topicRightLeftCard topicRightLeftCardRight">
                {/* Right Card Top Icon */}
                <div className="topicLeftRightCardRightTopIconContainer">
                  <img
                    src="images/topicAssets/Outcomes.png"
                    alt="Challenges"
                    className="topicLeftRightCardLeftTopIcon"
                  />
                </div>
                {/* Right Card Text Container */}
                <div className="topicLeftRightCardLeftTextContainer">
                  <p className="topicLeftRightCardRightTextHeading">Outcomes</p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Outcomes}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Outcomechild1}
                  </p>
                  <p className="topicLeftRightCardLeftTextP">
                    {props.Outcomehead}
                  </p>
                  <p className="topicLeftRightCardLeftTextP sublists">
                    {props.Outcomechild2}
                  </p>
                </div>
              </div>
            </div>
            {/* Topic Right Page Thumbnails Container */}
            <div className="topicRightPageRightThumbnailContainer">
              <div className="topicRightPageRightThumbnailInnerWrap">
                <p className="topicRightPageRightThumbnailHeading">
                  *Click on thumbnail for details
                </p>

                <div className="topicRightPageRightThumbnailCardContainer">
                  {/* Thumbnail Images start */}

                  <div
                    className="topicRightPageRightThumbnailCard"
                    onClick={() => {
                      handleOpen();
                      props.BookRef.current.pageFlip().flipPrev();
                    }}
                  >
                    {props.ThmbnailImg}
                  </div>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <div className="modalDialogMainContainer">
                      {/* Modal Header */}
                      <div className="modalTopicTitleContainer">
                        {/* Modal Title */}
                        <div className="modalTopicTitle">
                          {props.TopicTitleRight}
                        </div>
                        {/* Modal Close Button */}
                        <button
                          className="thumbnailModalCloseButton"
                          onClick={handleClose}
                        >
                          <img
                            src="images/close.png"
                            alt="Close"
                            className="modalCloseButton"
                          />
                        </button>
                      </div>
                      {/* Modal Body */}
                      <div className="modalBodyContainer">
                        {props.BigThumbnailImg}
                        {/* <Carousel>
                        <Carousel.Item>
                          <div className="modalBodyImagesContainer">
                            <img
                              src="images/topicAssets/TopicOneA/1.jpg"
                              alt="One"
                              className="modalBodyImages"
                            />
                          </div>
                        </Carousel.Item>
                        <Carousel.Item>
                          <div className="modalBodyImagesContainer">
                            <img
                              src="images/topicAssets/TopicOneA/2.jpg"
                              alt="One"
                              className="modalBodyImages"
                            />
                          </div>
                        </Carousel.Item>
                        <Carousel.Item>
                          <div className="modalBodyImagesContainer">
                            <img
                              src="images/topicAssets/TopicOneA/3.jpg"
                              alt="One"
                              className="modalBodyImages"
                            />
                          </div>
                        </Carousel.Item>
                      </Carousel> */}
                      </div>
                    </div>
                  </Modal>
                  {/* Thumbnail Images End */}
                  {/* Thumbnail Video Start */}
                  {props.PageNumber == "102" ||
                  props.PageNumber == "48" ||
                  props.PageNumber == "104" ||
                  props.PageNumber == "116" ||
                  props.PageNumber == "138" ||
                  props.PageNumber == "148" ||
                  props.PageNumber == "150" ||
                  props.PageNumber == "168" ||
                  props.PageNumber == "190" ||
                  props.PageNumber == "196" ||
                  props.PageNumber == "198" ||
                  props.PageNumber == "204" || 
                  props.PageNumber == "216" ||
                  props.PageNumber == "218" ||
                  props.PageNumber == "222" ||
                  props.PageNumber == "230" ||
                  props.PageNumber == "244" ||
                  props.PageNumber == "246" ||
                  props.PageNumber == "248" ? (
                    <div></div>
                  ) : (
                    <div
                      className="topicRightPageRightThumbnailCardVideo"
                      onClick={() => {
                        handleOpen1();
                        props.BookRef.current.pageFlip().flipPrev();
                      }}
                    >
                      <p className="topicRightPageRightThumbnailCardVideoTextHeading">
                        {props.VideoThumbnailTitle}
                      </p>
                      <p className="topicRightPageRightThumbnailCardVideoTextSubheading">
                        *Click on the button to play the video
                      </p>
                      <img
                        src={props.VideoThumanailImg}
                        alt="Thumbnail Img"
                        className="topicRightPageRightThumbnailImages"
                      />
                    </div>
                  )}
                  {/* Thumbnail Video End */}
                  <Modal
                    open={open1}
                    onClose={handleClose1}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <div className="modalDialogMainContainer">
                      {/* Modal Header */}
                      <div className="modalTopicTitleContainer">
                        {/* Modal Title */}
                        <div className="modalTopicTitle">
                          {props.TopicTitleRight}
                        </div>
                        {/* Modal Close Button */}
                        <button
                          className="thumbnailModalCloseButton"
                          onClick={handleClose1}
                        >
                          <img
                            src="images/close.png"
                            alt="Close"
                            className="modalCloseButton"
                          />
                        </button>
                      </div>
                      {/* Modal Body */}
                      <div className="modalBodyContainer">
                        <iframe
                          id="kmsembed-1_143gggub"
                          style={{ marginTop: "30px" }}
                          width="900"
                          height="450"
                          src={props.VideoModalLink}
                          class="kmsembed"
                          allowfullscreen
                          webkitallowfullscreen
                          mozAllowFullScreen
                          allow="autoplay *; fullscreen *; encrypted-media *"
                          referrerPolicy="no-referrer-when-downgrade"
                          frameborder="0"
                          title="Collaborative SAP Applications with MSFT Teams"
                        ></iframe>
                      </div>
                    </div>
                  </Modal>
                  {/* Thumbnail Video End */}
                </div>
              </div>
            </div>
          </div>
          {/* Topic Right Page Cards end */}
        </div>
        <p className="topicPageNumbers">{props.PageNumber}</p>
      </div>
    </div>
  );
});

// Last Page

const LastPageCover = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref} data-density="hard">
      <div className="contentWrapper">
        <div className="lastPageContent">
          {/* Thank you card */}
          <div className="lastPageThankyouCardBorderContainer">
            <img
              src="images/lastPage/lastPageThank.png"
              alt="!"
              className="lastPageThankYouTextCard"
            />
          </div>
          {/* Contact Details */}
          <div className="lastPageContactDetailsContainer">
            <p className="lastPageContactDetailsText">
              <img
                src="images/lastPage/Email.png"
                alt=""
                className="lastPageContactDetailsMailIcon"
              />
              &nbsp; Contact for more details:{" "}
              <a
                href="mailto:SAP.InnovationHub.Blr@accenture.com"
                className="lastPageContactDetailsLinkForEmail"
              >
                SAP.InnovationHub.Blr@accenture.com
              </a>
            </p>
          </div>
          {/* All rights */}
          <div className="lastPageAllRightsContainer">
            <p className="lastPageAllRightsTextLeft">
              &copy;2024 Accenture. All Rights Reserved.
            </p>
            <p className="lastPageAllRightsTextRIght">
              Accenture Confidentail.For internal use only.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

function FlipbookMainContent() {
  const book = useRef();
  const [eventHandler, setEventHandler] = useState("");
  const [page, setPage] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const onFlip = (e) => {
    setPage(e.data);
    console.log(e.data);
    if (eventHandler !== "") {
      book.current.pageFlip().flip(page);
      setEventHandler("");
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      book.current.pageFlip().flip(parseInt(e.target.value));
      console.log(e);
    }
  };
  const handlepageChange = (e) => {
    const event = e.target.value;
    // const pageFlip = parseInt(event);
    setPage(event);
    // book.current.pageFlip().flip(parseInt(event))
    //  setPage(event);
    console.log(event);
    //  console.log(pageFlip);
    console.log(typeof event);
  };

  // Download PDF
  const downloadPDF = () => {
    // using Java Script method to get PDF file
    fetch(SapPDF).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = SapPDF;
        alink.click();
      });
    });
  };
  const [temp, setTemp] = useState("");
  useEffect(() => {
        const homeUrl = async () => {
            const result = await axios.get(`${baseUrl}/homeUrl`)
            const { data: { Url } } = result
            console.log("test", Url)
            setTemp(Url)
        }
        homeUrl()
    }, []);
  return (
    <>
      <div>
        {/* Header Updated Start*/}
        <div className="headerWrapper">
          <div className="headerContainer">
            {/* Logo */}
            <div className="headerAccentureLogoLKMtextContainer">
              <div className="accentureLogoContainer">
                <img
                  src="images/Acc_Logo_Black_Purple_RGB.png"
                  alt="Accenture"
                  className="accentureLogo"
                />
                <p className="headerLkmText">SAP Innovations</p>
              </div>
              <p className="ltt_p"><a
                style={{ textDecoration: "none", color: "black" }}
                href={temp ? temp : ''}
                target="_blank"
              >
                L&TT Home
              </a></p>
            </div>
            {/* NavButtons */}
            <div className="headerNavButtonsWrapper">
              <div className="headerNavButtonsContainer">
                <div
                  className="headerNavButtonCon"
                  onClick={() => book.current.pageFlip().flip(1)}
                >
                  <img
                    src="images/header/toc.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div>
                <div
                  className="headerNavButtonCon"
                  onClick={() => book.current.pageFlip().flipPrev()}
                >
                  <img
                    src="images/header/previous.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div>
                {/* Page num */}
                <div className="headerNavPageNumberContainer">
                  <img
                    src="images/header/number.png"
                    alt=""
                    className="headerNavPageNumImg"
                  />
                  <p className="headerNavPageNumber">
                    <span>
                      <input
                        value={page}
                        pattern="^-?[0-9]\d*\.?\d*$"
                        onKeyPress={handleKeyDown}
                        onChange={handlepageChange}
                        className="headerPageNumberChange"
                      />
                    </span>
                    of 291
                  </p>
                </div>
                <div
                  className="headerNavButtonCon"
                  onClick={() => book.current.pageFlip().flipNext()}
                >
                  <img
                    src="images/header/next.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div>
                {/* <div onClick={downloadPDF} className="headerNavButtonCon">
                  <img
                    src="images/header/download.png"
                    alt=""
                    className="headerNavButton"
                  />
                </div> */}
              </div>
            </div>
            {/* Welcome Name */}
            <div className="headerWelcomeNameContainer">
              <p className="headerWelcomeName">
                <WelcomeName />
              </p>
              <img
                src="images/Avatar.png"
                alt="avatar"
                className="headerWelcomeNameAvatar"
              />
            </div>
          </div>
        </div>
        {/* Header Updated End */}
        <div className="FlipbookWrapper">
          <div style={{ width: "95%", margin: "auto", hight: "100vh" }}>
            <HTMLFlipBook
              width={350}
              height={320}
              size="stretch"
              maxShadowOpacity={0.15}
              autoSize={true}
              showCover={true}
              mobileScrollSupport={true}
              onFlip={onFlip}
              ref={book}
              drawShadow={true}
              className="FlipbookMainTag"
            >
              <PageCover></PageCover>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="contentWrapper">
                    <img
                      src="images/Content img 1.png"
                      alt="CoverImage"
                      className="coverImage"
                    />
                  </div>
                </div>
                <div className="tocSecondRowCardContainer">
                  <div className="contentWrapper"></div>
                </div>
                <div className="tocSecondRowCardContainer">
                  <div className="contentWrapper">
                    <img
                      src="images/Content img 2.png"
                      alt="CoverImage"
                      className="coverImage"
                    />
                  </div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(2)}>
                      <img
                        src="images/TOC/TOD 01!.png"
                        alt="Table of Content."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(4)}>
                      <img
                        src="images/TOC/Supply Chain 4.png"
                        alt="Table of Content."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(6)}>
                      <img
                        src="images/TOC/TOD 03!.png"
                        alt="Table of Content"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(8)}>
                      <img
                        src="images/TOC/TOD 04!.png"
                        alt="Table of Content."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    SAP Innovpedia represents a paradigm shift in how innovation
                    is fostered and leveraged to drive value. It serves as a
                    dynamic platform where Accenture's culture of innovation,
                    coupled with the unique skills, expertise and thought
                    process of our talented SAP practitioners, is unleashed.
                  </p>
                  <p className="tocTextRightSidePage para2">
                    With cutting-edge technologies, and opportunities to
                    co-create Innovative solutions, addressing niche and complex
                    business challenges, SAP Innovpedia offers all the latest
                    and greatest in one flipbook.
                    {""}
                  </p>
                  <p className="tocTextRightSidePage para3">
                    For more details, click{" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      href="https://in.accenture.com/sap/innovation-home/"
                      style={{ color: "blue" }}
                    >
                      SAP-Innovations
                    </a>
                    -and-
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      href="https://atc-networks.cop.accenture.com/#/platforms/sap/home"
                      style={{ color: "blue" }}
                    >
                      SAP CoP
                    </a>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(10)}>
                        <img
                          src="images/TOC/TOD 05.png"
                          alt="Table of Content."
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(12)}>
                        <img
                          src="images/TOC/TOD 07.png"
                          alt="Table of Content."
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(14)}>
                        <img
                          src="images/TOC/SAP Transformation.png"
                          alt="Table of Content."
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(16)}>
                        <img
                          src="images/TOC/TOD 08!!.png"
                          alt="Table of Content."
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    {/* sample commit */}
                  </div>
                </div>
              </PageTOCRight>

              {/* TOC of Finance */}
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(42)}>
                      <img
                        src="images/TOC/Finance 01.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(44)}>
                      <img
                        src="images/TOC/Finance 02.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(46)}>
                      <img
                        src="images/TOC/Finance 03.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(48)}>
                      <img
                        src="images/TOC/Finance 04.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Finance
                    </span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(50)}>
                      <img
                        src="images/TOC/Finance 05.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(52)}>
                      <img
                        src="images/TOC/Finance 06.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(54)}>
                      <img
                        src="images/TOC/Finance 07.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(56)}>
                      <img
                        src="images/TOC/Finance 08.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(54)}>
                      <img
                        src="images/TOC/Finance 09.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>

                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(56)}>
                      <img
                        src="images/TOC/Finance 10.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(58)}>
                      <img
                        src="images/TOC/Finance 11.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(60)}>
                      <img
                        src="images/TOC/Finance 12.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    Finance innovation use cases demonstrate the transformative
                    impact of emerging technologies on various aspects of the
                    finance industry, from operational efficiency and risk
                    management to customer experience and financial inclusion.
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                  <p className="tocTextRightSidePage para3">
                    {" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      style={{ color: "blue" }}
                    ></a>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(62)}>
                      <img
                        src="images/TOC/Finance 13.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(64)}>
                      <img
                        src="images/TOC/Gen AI 16.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(66)}>
                      <img
                        src="images/TOC/Gen AI-19.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(68)}>
                      <img
                        src="images/TOC/Gen AI 17.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
              </PageTOCRight>

              {/* TOC of Supply Chain */}
              <PageTOCLeft>
                {/* TOC 1st Row of Card Images */}
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(74)}>
                      <img
                        src="images/TOC/SC 01.png"
                        alt="Collaborative Applications with MS Teams & SAP Enterprise (BTP)."
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(76)}>
                      <img
                        src="images/TOC/SC 02.png"
                        alt="stock Inentory Mangement"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(78)}>
                      <img
                        src="images/TOC/SC 03.png"
                        alt="Supply Chain Mission Control"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(80)}>
                      <img
                        src="images/TOC/SC 04.png"
                        alt="Self Healing App"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(82)}>
                      <img
                        src="images/TOC/SC 05.png"
                        alt="NextGen Retread Process"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    Supply{" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Chain
                    </span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(84)}>
                      <img
                        src="images/TOC/SC 06.png"
                        alt="Design Workshop"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(86)}>
                      <img
                        src="images/TOC/SC 07.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(88)}>
                      <img
                        src="images/TOC/SC 08.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(90)}>
                      <img
                        src="images/TOC/SC 10.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(92)}>
                      <img
                        src="images/TOC/SC 11.png"
                        alt="Topic ThirtyOne"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(90)}>
                      <img
                        src="images/TOC/Gen AI-18.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(92)}>
                      <img
                        src="images/TOC/SC 13.png"
                        alt="Topic ThirtyOne"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(94)}>
                      <img
                        src="images/TOC/SC 14.png"
                        alt="Topic ThirtyOne"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(96)}>
                      <img
                        src="images/TOC/SC 15.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(98)}>
                      <img
                        src="images/TOC/SC 16.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    Supply chain management are transforming traditional
                    processes and driving unprecedented levels of efficiency,
                    visibility, and resilience. The latest innovations in supply
                    chain management are transforming to optimize efficiency,
                    enhance visibility, and mitigate risks across their supply
                    chain operations.
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                  <p className="tocTextRightSidePage para3">
                    {" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      style={{ color: "blue" }}
                    ></a>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(100)}>
                      <img
                        src="images/TOC/SC 17.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(102)}>
                      <img
                        src="images/TOC/SC 18.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(104)}>
                      <img
                        src="images/TOC/SCAI 18.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(106)}>
                      <img
                        src="images/TOC/SCAI 19.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(108)}>
                      <img
                        src="images/TOC/SCAI 20.png"
                        alt="Topic Seventeen"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
              </PageTOCRight>

              {/* TOC of Customer Experience */}
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(114)}>
                      <img
                        src="images/TOC/CX 01.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(116)}>
                      <img
                        src="images/TOC/CX 02.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(118)}>
                      <img
                        src="images/TOC/CX 03.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(120)}>
                      <img
                        src="images/TOC/CX 04.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">CX</span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(122)}>
                      <img
                        src="images/TOC/CX 05.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(124)}>
                      <img
                        src="images/TOC/CX 06.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(126)}>
                      <img
                        src="images/TOC/CX 07.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(128)}>
                      <img
                        src="images/TOC/CX 08.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(126)}>
                      <img
                        src="images/TOC/CX 09.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(128)}>
                      <img
                        src="images/TOC/CX 10.png"
                        alt="Customer Experience"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(130)}>
                      <img
                        src="images/TOC/Gen AI 15.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer"></div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    Customer experience innovation are reshaping the way
                    businesses interact with and serve their customers. By
                    leveraging technologies such as personalized product
                    recommendations, virtual assistants, augmented reality,
                    voice-activated interfaces, omni-channel engagement, and
                    predictive analytics, organizations can create memorable and
                    differentiated experiences that drive customer satisfaction,
                    loyalty, and advocacy.
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                  <p className="tocTextRightSidePage para3">
                    {" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      style={{ color: "blue" }}
                    ></a>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer"></div>
              </PageTOCRight>

              {/* TOC of Talent & HR */}

              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(136)}>
                        <img
                          src="images/TOC/T&H 01.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(138)}>
                        <img
                          src="images/TOC/T&H 02.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(140)}>
                        <img
                          src="images/TOC/T&H 03.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(142)}>
                        <img
                          src="images/TOC/T&H 04.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Talent & HR
                    </span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(144)}>
                        <img
                          src="images/TOC/T&H 05.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(146)}>
                        <img
                          src="images/TOC/T&H 06.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(148)}>
                        <img
                          src="images/TOC/T&H 07.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(150)}>
                        <img
                          src="images/TOC/T&H 08.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(148)}>
                        <img
                          src="images/TOC/T&H 09.png"
                          alt="Talent & HR"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer"></div>
                    <div className="tocRowCardsImgContainer"></div>
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    Talent and HR are driving transformative changes in how
                    organizations attract, develop, and retain talent in today's
                    dynamic workplace environment. Organizations are leveraging
                    innovative technologies and strategies to optimize HR
                    processes, enhance employee experience, and drive business
                    success.
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                  <p className="tocTextRightSidePage para3">
                    {" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      style={{ color: "blue" }}
                    ></a>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer"></div>
                </div>
              </PageTOCRight>
              {/* TOC of Gen AI */}
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(154)}>
                        <img
                          src="images/TOC/GenAI 20!.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(156)}>
                        <img
                          src="images/TOC/Gen AI 02.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(158)}>
                        <img
                          src="images/TOC/Gen AI 03.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(160)}>
                        <img
                          src="images/TOC/GenAI 04.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(162)}>
                        <img
                          src="images/TOC/GenAI 05.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    SAP{" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      GenAI
                    </span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(164)}>
                        <img
                          src="images/TOC/GenAI 06.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(166)}>
                        <img
                          src="images/TOC/HR Genie.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(168)}>
                        <img
                          src="images/TOC/GenAI 08.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(170)}>
                        <img
                          src="images/TOC/Gen AI 10.png"
                          alt="Gen AI"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                     <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(172)}>
                      <img
                        src="images/TOC/GenAI 11.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  </div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                {/* TOC 2nd Row of Card Images */}

                {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                <div className="tocFirstRowCardContainer">
                 
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(170)}>
                      <img
                        src="images/TOC/GenAI 12.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(172)}>
                      <img
                        src="images/TOC/GenAI 13.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(174)}>
                      <img
                        src="images/TOC/Qualisight_ Predict Manufacturing batch process quality.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(176)}>
                      <img
                        src="images/TOC/GenAI 15.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                   <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(178)}>
                      <img
                        src="images/TOC/Gen AI 16.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>

                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    Generative AI marks a significant shift in problem-solving
                    for SAP, with potential disruptions across multiple domains:
                    <ul>
                      <li>Data Simulation and Augmentation</li>
                      <li>Enhanced Forecasting & Anomaly Detection</li>
                      <li>Personalized User Experiences</li>
                      <li>Automated Content Creation</li>
                      <li>Process Automation</li>
                    </ul>
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                </div>
                <div className="tocFirstRowCardContainer">
                 
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(180)}>
                      <img
                        src="images/TOC/Gen AI 17.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(182)}>
                      <img
                        src="images/TOC/GenAI 18.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(184)}>
                      <img
                        src="images/TOC/Gen AI-19.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(186)}>
                      <img
                        src="images/TOC/GenAI 01.png"
                        alt="Gen AI"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                   <div className="tocRowCardsImgContainer"></div>
                </div>
              </PageTOCRight>

              {/* TOC of Data and Analytics*/}

              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer"></div>

                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    Data &{" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Analytics
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(188)}>
                      <img
                        src="images/TOC/D&A 01.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>

                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(190)}>
                      <img
                        src="images/TOC/D&A 02.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(192)}>
                      <img
                        src="images/TOC/D&A 03.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(194)}>
                      <img
                        src="images/TOC/D&A 04.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(196)}>
                      <img
                        src="images/TOC/D&A 05.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    Data and analytics are transforming businesses across every
                    industry, driving insights, and informing strategic
                    decisions. With the proliferation of big data, machine
                    learning, and artificial intelligence, organizations can
                    extract valuable information from vast datasets to optimize
                    operations, enhance customer experiences, and fuel
                    innovation.
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                  <p className="tocTextRightSidePage para3">
                    {" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      style={{ color: "blue" }}
                    ></a>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer"></div>
              </PageTOCRight>
              {/* TOC of Emerging Tech */}
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(202)}>
                      <img
                        src="images/TOC/Greenfield 01.png"
                        alt="GreenField"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(204)}>
                      <img
                        src="images/TOC/Greenfield 02.png"
                        alt="GreenField"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(206)}>
                      <img
                        src="images/TOC/Greenfield 03.png"
                        alt="GreenField"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>

                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(208)}>
                      <img
                        src="images/TOC/Greenfield 04.png"
                        alt="GreenField"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(210)}>
                      <img
                        src="images/TOC/Greenfield 05.png"
                        alt="GreenField"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    SAP{" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Greenfield
                    </span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(212)}>
                      <img
                        src="images/TOC/Greenfield 06.png"
                        alt="GreenField"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(210)}>
                      <img
                        src="images/TOC/Smart()field 01.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(212)}>
                      <img
                        src="images/TOC/Smart()field 02.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(214)}>
                      <img
                        src="images/TOC/Smart()field 03.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(216)}>
                      <img
                        src="images/TOC/Smart()field 04.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(218)}>
                      <img
                        src="images/TOC/Smart()field 05.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  {/* <p className="tocTextRightSidePage para1">
                    
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                  <p className="tocTextRightSidePage para3">
                    {" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      style={{ color: "blue" }}
                    ></a>
                  </p> */}
                  <p className="tocHeadingSecondRow">
                    SAP Smart()field{" "}
                    <span className="tocHeadingSecondRowContentSpan"></span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(220)}>
                      <img
                        src="images/TOC/Smart()field 06.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(222)}>
                      <img
                        src="images/TOC/Smart()field 07.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(224)}>
                      <img
                        src="images/TOC/Smart()field 08.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(226)}>
                      <img
                        src="images/TOC/Smart()field 09.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(228)}>
                      <img
                        src="images/TOC/Smart()field 10.png"
                        alt="S/4 HANA"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
              </PageTOCRight>

              {/* TOC of Industry */}
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(234)}>
                        <img
                          src="images/TOC/Sustainability 01.jpg"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(236)}>
                        <img
                          src="images/TOC/Sustainability 02.jpg"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(238)}>
                        <img
                          src="images/TOC/Sustainability 03.jpg"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(240)}>
                        <img
                          src="images/TOC/Sustainability 04.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Sustainability
                    </span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer"></div>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(18)}>
                      <img
                        src="images/TOC/Industry 01.png"
                        alt="Industry"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(20)}>
                      <img
                        src="images/TOC/Industry 02.png"
                        alt="Industry"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(22)}>
                      <img
                        src="images/TOC/Industry 03.png"
                        alt="Industry"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(24)}>
                      <img
                        src="images/TOC/Industry 04.png"
                        alt="Industry"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(26)}>
                      <img
                        src="images/TOC/Industry 05.png"
                        alt="Industry"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Industry
                    </span>
                  </p>
                </div>

                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(28)}>
                        <img
                          src="images/TOC/Industry 06.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(30)}>
                        <img
                          src="images/TOC/Industry 07.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(32)}>
                        <img
                          src="images/TOC/Industry 08.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(34)}>
                        <img
                          src="images/TOC/Industry 09.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(36)}>
                        <img
                          src="images/TOC/Industry 10.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      High Tech
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(238)}>
                      <img
                        src="images/TOC/HT 01.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(240)}>
                      <img
                        src="images/TOC/ET 01.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(242)}>
                      <img
                        src="images/TOC/HT 03.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer"></div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan"></span>
                  </p>
                </div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Comms & Media
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(244)}>
                        <img
                          src="images/TOC/CM 01.png"
                          alt="Emerging Tech"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(246)}>
                        <img
                          src="images/TOC/CM 02.png"
                          alt="Emerging Tech"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer"></div>
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer"></div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Software & Platforms
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer"></div>
                </div>
                {/* TOC 2nd Row of Card Images */}

                {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Coming soon!
                    </span>
                  </p>
                </div>

                <p className="tocTextRightSidePage para2">{""}</p>
                <p className="tocTextRightSidePage para3">
                  {" "}
                  <a
                    className="tocTextRightSidePageAtag"
                    rel="noreferrer"
                    target="_blank"
                    style={{ color: "blue" }}
                  ></a>
                </p>

                <div className="tocFirstRowCardContainer"></div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Public Service
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(248)}>
                        <img
                          src="images/TOC/Defense 01.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(250)}>
                        <img
                          src="images/TOC/Defense 02.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(252)}>
                        <img
                          src="images/TOC/Defense 03.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(254)}>
                        <img
                          src="images/TOC/Defense 04.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  {/* <p className="tocHeadingSecondRow">
              Table of{" "}
              <span className="tocHeadingSecondRowContentSpan">Contents</span>
            </p> */}
                  <p className="tocTextRightSidePage para1">
                    The Defense industry plays a critical role in safeguarding
                    national security and addressing global threats. With
                    advancements in technology, defense organizations are
                    increasingly leveraging cutting-edge innovations such as
                    artificial intelligence, robotics, and cyber warfare
                    capabilities to enhance military effectiveness and
                    operational efficiency.
                  </p>
                  <p className="tocTextRightSidePage para2">{""}</p>
                  <p className="tocTextRightSidePage para3">
                    {" "}
                    <a
                      className="tocTextRightSidePageAtag"
                      rel="noreferrer"
                      target="_blank"
                      style={{ color: "blue" }}
                    ></a>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer"></div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Industrial
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(256)}>
                        <img
                          src="images/TOC/Ind 01.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(258)}>
                        <img
                          src="images/TOC/Ind 02.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(260)}>
                        <img
                          src="images/TOC/Ind 03.png"
                          alt="Industry"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>
              </PageTOCRight>

              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      CG&S and Retail
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(262)}>
                        <img
                          src="images/TOC/CGS 01.png"
                          alt="Topic Twenty"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(264)}>
                        <img
                          src="images/TOC/CGS 02.png"
                          alt="Topic Twenty"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(266)}>
                        <img
                          src="images/TOC/CGS 03.png"
                          alt="Topic Twenty"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(268)}>
                        <img
                          src="images/TOC/Retail 01.png"
                          alt="Topic Twenty"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan"></span>
                  </p>
                </div>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(270)}>
                      <img
                        src="images/TOC/Retail 02.png"
                        alt="Topic Twenty"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(272)}>
                      <img
                        src="images/TOC/Retail 03.png"
                        alt="Topic Twenty"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                </div>
                {/* TOC 2nd Row of Card Images */}
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Life Sciences
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(274)}>
                        <img
                          src="images/TOC/LS 01.png"
                          alt="Topic Twenty"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(276)}>
                        <img
                          src="images/TOC/LS 02.png"
                          alt="Cell Gene Therapy​"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(278)}>
                        <img
                          src="images/TOC/LS 03.png"
                          alt="Cell Gene Therapy​"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(280)}>
                        <img
                          src="images/TOC/LS 04.png"
                          alt="Cell Gene Therapy​"
                          className="tocRowCardImgs"
                        />
                      </a>
                    </div>
                    <div className="tocRowCardsImgContainer">
                      <a onClick={() => book.current.pageFlip().flip(282)}>
                      <img
                        src="images/TOC/Qualisight_ Predict Manufacturing batch process quality.png"
                        alt="Emerging Tech"
                        className="tocRowCardImgs"
                      />
                    </a>
                    </div>
                  </div>
                </div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer">
                      
                    </div>
                     <div className="tocRowCardsImgContainer"></div>
                      <div className="tocRowCardsImgContainer"></div>
                       <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Chemicals and Natural Resources
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Coming soon!
                    </span>
                  </p>
                </div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Energy
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocFirstRowCardContainer">
                    <div className="tocRowCardsImgContainer"></div>
                  </div>
                </div>
                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Coming soon!
                    </span>
                  </p>
                </div>
              </PageTOCRight>
              <PageTOCLeft>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                  <div className="tocRowCardsImgContainer"></div>
                </div>

                {/* TOC 2nd Row of Card Images */}
                <div className="tocSecondRowCardContainer">
                  <p className="tocHeadingSecondRow">
                    {" "}
                    <span className="tocHeadingSecondRowContentSpan">
                      Utilities
                    </span>
                  </p>
                </div>
              </PageTOCLeft>
              <PageTOCRight>
                <div className="tocFirstRowCardContainer">
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(284)}>
                      <img
                        src="images/TOC/US 01.png"
                        alt="PI Sheet Blending Simulation"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(286)}>
                      <img
                        src="images/TOC/US 02.png"
                        alt="Green House Gas Management Dashboard​"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer">
                    <a onClick={() => book.current.pageFlip().flip(288)}>
                      <img
                        src="images/TOC/US 03.png"
                        alt="Green House Gas Management Dashboard​"
                        className="tocRowCardImgs"
                      />
                    </a>
                  </div>
                  <div className="tocRowCardsImgContainer"></div>
                </div>
              </PageTOCRight>

              {/* Page */}

              {FlipbookData.pages.map((item, index) => {
                if (item.pageNumber % 2 !== 0) {
                  return (
                    <TopicPageLeft
                      PageNumber={item.pageNumber}
                      TopicCount={item.topicCount}
                      TopicTitle={item.topicTitle}
                      LeftPageBgImage={item.leftPageBGImage}
                      Challenge={
                        <p>
                          {item.challenge.map((item1, index) => {
                            return <span>{item1}</span>;
                          })}
                        </p>
                      }
                      ChallengeSubchild={
                        <ul>
                          {item.challengeSubchild.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Solution={
                        <ul>
                          {item.solution.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Subchild={
                        <ul>
                          {item.subchild.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                    ></TopicPageLeft>
                  );
                } else {
                  return (
                    <TopicPageRight
                      BookRef={book}
                      PageNumber={item.pageNumber}
                      Industry={item.industry}
                      Domain={item.domain}
                      KeyFeatures={
                        <ul>
                          {item.keyFeatures.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Keysubchild={
                        <ul>
                          {item.keysubchild.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomes={
                        <ul>
                          {item.outcomes.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomechild1={
                        <ul>
                          {item.outcomechild1.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomehead={
                        <ul>
                          {item.outcomehead.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      Outcomechild2={
                        <ul>
                          {item.outcomechild2.map((item1, index) => {
                            return <li>{item1}</li>;
                          })}
                        </ul>
                      }
                      ThmbnailImg={
                        <>
                          {item.thmbnailImg.map((item1, index) => {
                            return (
                              <img
                                src={item1}
                                alt="Thumbnail Img"
                                className="topicRightPageRightThumbnailImages"
                              />
                            );
                          })}
                        </>
                      }
                      BigThumbnailImg={
                        <>
                          <Carousel>
                            {item.bigThumbnailImg.map((item1, index) => {
                              return (
                                <Carousel.Item>
                                  <div className="modalBodyImagesContainer">
                                    <img
                                      src={item1}
                                      alt="One"
                                      className="modalBodyImages"
                                    />
                                  </div>
                                </Carousel.Item>
                              );
                            })}
                          </Carousel>
                        </>
                      }
                      VideoThumbnailTitle={item.videoThumbnailTitle}
                      VideoThumanailImg={item.videoThumanailImg}
                      TopicTitleRight={item.topicTitleRight}
                      VideoModalLink={item.videoModalLink}
                    ></TopicPageRight>
                  );
                }
              })}
              <LastPageCover></LastPageCover>
            </HTMLFlipBook>
          </div>
        </div>
      </div>
    </>
  );
}

export default FlipbookMainContent;
